<template>
  <b-nav vertical v-if="artist" class="navlinks">
    <b-nav-item :to="{name: 'artist-dashboard'}" class="nl">
      <i class="sl-icon-home" /> Dashboard
    </b-nav-item>
    <b-nav-item :to="{name: 'artist-video-list', params: {visibility: 'public'}}" class="nl">
      <i class="sl-icon-layers" /> Videos
    </b-nav-item>
    <b-nav-item :to="{name: 'artist-album-list', params: {visibility: 'public'}}" class="nl">
      <i class="sl-icon-playlist" /> Albums
    </b-nav-item>
    <b-nav-item :to="{name: 'artist-my-live-stream-list', params: { visibility: 'public'}}" class="nl">
      <i class="sl-icon-camrecorder" /> Live streams
    </b-nav-item>
    <b-nav-item :to="{name: 'artist-profile-edit'}" class="nl">
      <i class="sl-icon-settings" /> Channel
    </b-nav-item>
    <b-nav-item :to="{name: 'artist-followers'}" class="nl" v-if="withProfileLinks">
      <i class="sl-icon-user" /> {{ followerCount }}
    </b-nav-item>
  </b-nav>
  <b-nav vertical v-else class="navlinks">
    <b-nav-item :to="{name: 'fan-home'}" class="nl">
      <i class="sl-icon-home" /> Home
    </b-nav-item>
    <b-nav-item :to="{name: 'fan-followed-artists'}" class="nl" v-if="withProfileLinks">
      <i class="sl-icon-user" /> Following {{ followedArtists.length }}
    </b-nav-item>
    <b-nav-item :to="{name: 'discover'}" class="nl">
      <i class="sl-icon-energy" /> Browse
    </b-nav-item>
    <b-nav-item :to="{name: 'fan-playlist-list', meta: {type: 'my'}}" class="nl">
      <i class="sl-icon-playlist" /> Playlists
    </b-nav-item>
    <b-nav-item :to="{name: 'fan-history'}" class="nl">
      <i class="sl-icon-clock" /> Recent Plays
    </b-nav-item>
    <b-nav-item :to="{name: 'fan-playlist-detail', params: { id: myVideos.id } }" v-if="myVideos" class="nl">
      <i class="sl-icon-layers" /> Saved Videos
    </b-nav-item>
    <b-nav-item :to="{name: 'fan-downloads'}" class="nl">
      <i class="sl-icon-cloud-download" /> Downloads
    </b-nav-item>
    <b-nav-item :to="{name: 'fan-watchlist'}" class="nl">
      <i class="sl-icon-eye" /> Watchlist
    </b-nav-item>
  </b-nav>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .navlinks {
    text-align: left;
    font-size: 0.9em;
    width: 100%;
    padding-left: 18px;

    &.padded {
      margin-top: 1em;
      padding-top: 2em;
    }

    .nl {
      @include media-breakpoint-up(md) {
        margin-top: 0.5em;
        margin-bottom: 0.5em;
      }

      a {
        color: $steel;

        &.active {
          color: $body-color;
        }

        &:hover {
          color: $body-color;
        }

        i {
          margin-right: 1em;
        }
      }
    }
  }
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NavLinks',
  props: {
    artist: Boolean,
    withProfileLinks: Boolean
  },
  computed: {
    myVideos () {
      return this.currentUser.default_playlists ? this.currentUser.default_playlists.my_videos : null
    },
    followerCount () {
      const count = this.$store.getters['artist/artist'].follower_count || 0
      return `${count} Follower` + ((count === 1) ? '' : 's')
    },
    ...mapGetters('profile', ['currentUser', 'isArtist', 'followedArtists'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/NavLinks.vue